import { makeStyles } from '@shared/theme';

const useStyles = makeStyles(({ spacing }, { units }: { units: number }) => ({
  root: {
    '& > * + *': {
      marginTop: spacing(units),
    },
  },
}));

const useChildrenSpacing = (units: number) => useStyles({ units }).classes.root;

export default useChildrenSpacing;
